import { render, staticRenderFns } from "./VehiclePrice.vue?vue&type=template&id=768434e0&"
import script from "./VehiclePrice.vue?vue&type=script&lang=js&"
export * from "./VehiclePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports